// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FuxgD","mini":"styles_mini__o6VXl","openButton":"styles_openButton__gfvjC","title":"styles_title__CptzP","link":"styles_link__PbPgC"};